import { isBlank } from "ionic-angular/util/util";

export const makeAlias = (text: string): string => {

    if (isBlank(text)) {
        return "";
    }

    return text
        .trim()
        .toLowerCase()
        .replace(/([^A-Z0-9]+|\s+|-+)/gi, match => {
            let replacement = "";
            if (match.match(/(\s+|-+)/i)) {
                replacement = "-";
            }
            return replacement;
        })
        .replace(/^[-\s]/, "")
        .replace(/[-\s]$/, "");
};

export const makeNameAlias = (text: string): string => {

    if (isBlank(text)) return "";

    const parts = text.match(/[\w]+/g);
    if (isBlank(parts)) return "";

    return parts.map((val, index) => index === 0
                                                ? val.toLowerCase()
                                                : val[0].toUpperCase() + val.substr(1).toLowerCase())
                .join("");
};



// WEBPACK FOOTER //
// ./src/core/util/make-alias.ts